const DEVICE_ID_KEY = 'filmple:device-id';

/** Returns stable install ID, or null if persistent storage is unavailable.
 *  Callers must treat null as "skip device-seen" (fail closed). */
export function getOrCreateDeviceId(): string | null {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
    // Verify the write stuck (Safari private mode silently drops writes)
    if (localStorage.getItem(DEVICE_ID_KEY) !== id) return null;
    return id;
  } catch {
    return null; // storage unavailable — fail closed, do not generate ephemeral ID
  }
}
